import { type ActionItem } from 'shared/ui'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import { type IUser } from 'entities/Users/model/types'
import { type IParamsUpdateMemberPermissions, type IResponseUser } from 'entities/Users/api/types'
import { UpgradeMemberStore } from 'pages/settings/pages/members/ui/actions/upgradeMember/ui/UpgradeMemberModal/store/UpgradeMemberStore'

export const upgradeMemberAction = (
  member: IUser,
  entities: IEntitiesStore,
  params: IParamsUpdateMemberPermissions,
  onSuccess?: (member: IResponseUser) => void | Promise<void>
) => {
  const onUpgrade = () => new UpgradeMemberStore(member, entities, params, onSuccess)

  return onUpgrade()
}

export const upgradeMember = (
  member: IUser,
  entities: IEntitiesStore,
  params: IParamsUpdateMemberPermissions,
  onSuccess?: (member: IResponseUser) => void | Promise<void>
): ActionItem => {
  return {
    text: 'Upgrade',
    icon: 'transfer',
    onAction: () => {
      upgradeMemberAction(member, entities, params, onSuccess)
    },
  }
}
